import React, { useEffect } from "react";

interface IHtmlContentRendererProps {
  htmlString: string;
}

const HtmlContentRenderer: React.FC<IHtmlContentRendererProps> = ({
  htmlString,
}) => {

  // These cookies were configured for authorization within the image API request.
  useEffect(() => {
    const chartId = sessionStorage.getItem("chartId");
    const token = localStorage
      .getItem("openProjectAccessToken")
      ?.replace(/"/g, "");
    const setCookie = (
      name: string,
      value: string,
      options: Record<string, string | boolean> = {}
    ) => {
      if (!value) {
        console.warn(
          `Cookie value for '${name}' is null or undefined. Not setting cookie.`
        );
        return;
      }

      let cookieString = `${name}=${value}`;
      if (!options.path) {
        options.path = "/";
      }

      for (const optionKey in options) {
        if (options.hasOwnProperty(optionKey)) {
          cookieString += `; ${optionKey}`;
          const optionValue = options[optionKey];
          if (optionValue !== true) {
            cookieString += `=${optionValue}`;
          }
        }
      }
      document.cookie = cookieString;
    };

    if (chartId) {
      setCookie("chartId", chartId, {
        path: "/",
      });
    } else {
      console.warn(
        "chartId not found in sessionStorage. Cookie 'chartId' not set."
      );
    }

    if (token) {
      setCookie("token", token, {
        path: "/",
        secure: true,
      });
    } else {
      console.warn(
        "openProjectAccessToken not found in localStorage. Cookie 'token' not set."
      );
    }
  }, []);

  if (!htmlString) {
    return null;
  }
  const cleanHtmlString = htmlString?.replace(/\\n/g, "").replace(/\\"/g, '"');

  return (
    <div
      className="html-content-container"
      dangerouslySetInnerHTML={{ __html: cleanHtmlString }}
    />
  );
};

export default HtmlContentRenderer;
